<template>
  <div class="mt-5 flex">
    <i class="mt-2 fas fa-minus mr-5"></i>
    <div class="flex flex-col">
      <h3 class="text-lg font-bold text-gray-600">{{ name }}</h3>
      <span class="text-gray-500 font-medium">{{ designation }}</span>
      <span v-if="email" class="text-gray-600 mt-2 font-medium hover:text-pink-600"><a
          :href="`mailto:${email}`"><i class="pi pi-envelope"></i> {{ email }}</a></span>
      <span v-if="mobile" class="text-gray-600 font-medium hover:text-pink-600"><i class="pi pi-mobile"></i> {{
          mobile
        }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Signature",
  props: {
    name: String,
    designation: String,
    email: String,
    mobile: String
  }
}
</script>

<style scoped>

</style>